// Widget'ların en üstündeki başlık. Gömen kişi `headerTitle` attribute'u ile
// metni değiştirebilir; verilmezse widget'ın varsayılan başlığı (children) yazılır.
const WidgetTitle = ({ title, children }) => (
	<div className="widget-title">
		<h2 className="widget-title__text">{title?.trim() || children}</h2>
		<span className="widget-title__bar" aria-hidden="true" />
	</div>
);

export default WidgetTitle;
